var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useState } from 'react';
import { TabContent, TabLink, Tabs } from 'react-tabs-redux';
import { Translate } from "../I18N";
import { SettingsHeader } from "../Settings/components/SettingsHeader";
import { UserGroups } from "./components/usergroups/UserGroups";
import { Users } from "./components/Users";

export const roleTranslationKey = {
  admin: 'Admin',
  editor: 'Editor',
  collaborator: 'Collaborator'
};

export const UserManagement = () => {
  const [selectedTab, setSelectedTab] = useState('users');
  return /*#__PURE__*/(
    _jsx("div", { className: "settings-content" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "panel panel-default" }, void 0, /*#__PURE__*/
    _jsx(SettingsHeader, {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Users")), /*#__PURE__*/

    _jsx("div", { className: "userManagementTabs" }, void 0, /*#__PURE__*/
    _jsx(Tabs, { selectedTab: selectedTab, renderActiveTabContentOnly: true, handleSelect: setSelectedTab }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("ul", { className: "nav" }, void 0, /*#__PURE__*/
    _jsx("li", {}, void 0, /*#__PURE__*/
    _jsx(TabLink, { to: "users", component: "div" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Users"))), /*#__PURE__*/


    _jsx("li", {}, void 0, /*#__PURE__*/
    _jsx(TabLink, { to: "usergroups", component: "div" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Groups"))))), /*#__PURE__*/




    _jsx(TabContent, { for: "users" }, void 0, /*#__PURE__*/
    _jsx(Users, {})), /*#__PURE__*/

    _jsx(TabContent, { for: "usergroups" }, void 0, /*#__PURE__*/
    _jsx(UserGroups, {})))))));






};